
import React from 'react';
import { Progress } from '@/components/ui/progress';

export interface ProgressIndicatorProps {
  completedSteps?: number;
  totalSteps?: number;
  basicInfoComplete?: boolean;
  addressComplete?: boolean;
  industryComplete?: boolean;
  basicInfoEdited?: boolean;
  addressEdited?: boolean;
  industryEdited?: boolean;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ 
  completedSteps = 0,
  totalSteps = 3,
  basicInfoComplete = false,
  addressComplete = false,
  industryComplete = false,
  basicInfoEdited = false,
  addressEdited = false,
  industryEdited = false
}) => {
  // Calculate progress based on completed steps if provided, otherwise use section completion
  let progressPercentage = (completedSteps / totalSteps) * 100;
  
  // If the section completion props are provided, use them instead
  if (basicInfoComplete !== undefined) {
    let completed = 0;
    if (basicInfoEdited) completed++;
    if (addressEdited) completed++;
    if (industryEdited) completed++;
    progressPercentage = (completed / 3) * 100;
  }
  
  return (
    <div>
      <Progress value={progressPercentage} className="h-2" />
    </div>
  );
};

export default ProgressIndicator;
